export default {
  LANG_CODE: 'en',
  LANG_NOT_FOUND: 'Currently we are not supporting the language you are trying to select.',
  LANG_HAS_DELETED: 'Currently we are not supporting the selected language, please contact to our support team.',
  USER_ID: 'User Id',
  USER_NAME: 'Username',
  PASSWORD: 'Password',
  REQUIRED_FIELD: 'is a required field',
  FORGOT_PASSWORD: 'Forgot password',
  API_DEFAULT_ERROR: 'Something went wrong, please try again after sometime.',
  SUPPORT_LABEL: 'for login or password issues contact',
  BACK_TO_LOGIN: 'Back to login',
  SUBMIT: 'Submit',
  YES: 'Yes',
  NO: 'No',
  DELETE: 'Delete',
  LOGOUT: 'Logout',
  LOGOUT_POPUP_TITLE: 'Do you want to log out?',
  EVENT_INFO: 'Event info',
  QUALIFYING_QUESTIONS: 'Qualifying questions',
  CONTENT: 'Content',
  EMAILS: 'Emails',
  PREVIOUS: 'Previous',
  CONTINUE: 'Continue',
  FINISH: 'Finish',
  ADD: 'Add',
  CANCEL: 'Cancel',
  APPROVE: 'Approve',
  INVALID_FIELD: 'field is invalid',
  SET: 'Set',
  EXHIBITORS: 'Exhibitors',
  EVENT_ID: 'Event Id',
  PASS_MIN_LEN_ERROR: 'should contain atleast 6 characters.',
  SAVE: 'Save',
  EDIT: 'Edit',
  COOCKIE_POLICY: 'Cookie policy',
  COOCKIE_TEXT:
    'Cookies help us provide our services. We are using technical cookies to provide you the best experience of our site. By closing this window or by continuing to use the site, you are agreeing to our use of such cookies. Find out more in our',
  COOCKIE_POLICY_LINK: 'https://fielddrive.com/cookie-policy/',
  SUCCESS_TITLE: 'Success!',
  FAILED_TITLE: 'Failed!',
  OR: 'Or',
  EVENT_SETTINGS: 'Event Settings',
  LEADS: 'Leads',
  COPIED: 'Copied!',
  PREVIEW: 'Preview',
  RENAME: 'Rename',
  DELETE_LABEL: 'Do you want to delete this'
}
